export function TrashIcon() {
  return (
    <svg className="trash-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M9 4h6l1 2h4v2H4V6h4l1-2Z" />
      <path d="M7 10h10l-.7 9.1a1 1 0 0 1-1 .9H8.7a1 1 0 0 1-1-.9L7 10Z" />
      <path d="M10 12.5v5M14 12.5v5" />
    </svg>
  );
}
